import _ from 'underscore';

import { RECOMMENDATION_TYPES, formatBid, NOT_SUPPORT_DOWNLOAD_TYPES } from '@bingads-webui-campaign/recommendation-core';
import { RECOMMENDATION_INLINE_ACTION_TYPE } from '@bingads-webui-campaign/recommendation-inline-action';

export const INLINE_ACTION_MAP = {
  [RECOMMENDATION_TYPES.BUDGET_OPPORTUNITY]: RECOMMENDATION_INLINE_ACTION_TYPE.APPLY_EDIT,
  [RECOMMENDATION_TYPES.ADJUST_SHARED_BUDGET_OPPORTUNITY]:
    RECOMMENDATION_INLINE_ACTION_TYPE.APPLY_EDIT,
  [RECOMMENDATION_TYPES.REALLOCATE_BUDGET]: RECOMMENDATION_INLINE_ACTION_TYPE.APPLY_EDIT,
  [RECOMMENDATION_TYPES.IMAGE_EXTENSION]: RECOMMENDATION_INLINE_ACTION_TYPE.IMAGE_EXTENSION,

  [RECOMMENDATION_TYPES.BROAD_MATCH_KEYWORD]: RECOMMENDATION_INLINE_ACTION_TYPE.APPLY_ONLY,
  [RECOMMENDATION_TYPES.NEW_KEYWORD_OPPORTUNITY]: RECOMMENDATION_INLINE_ACTION_TYPE.APPLY_ONLY,
  [RECOMMENDATION_TYPES.TRENDING_QUERY]: RECOMMENDATION_INLINE_ACTION_TYPE.APPLY_ONLY,
  [RECOMMENDATION_TYPES.REMOVE_CONFLICTING_NEGATIVE_KEYWORD]:
    RECOMMENDATION_INLINE_ACTION_TYPE.APPLY_ONLY,
  [RECOMMENDATION_TYPES.REPAIR_MISSING_KEYWORD_PARAMS]:
    RECOMMENDATION_INLINE_ACTION_TYPE.APPLY_ONLY,
  [RECOMMENDATION_TYPES.FIX_NO_IMPRESSION_BID]: RECOMMENDATION_INLINE_ACTION_TYPE.APPLY_ONLY,
  [RECOMMENDATION_TYPES.REPAIR_UNTARGETED_OFFER]: RECOMMENDATION_INLINE_ACTION_TYPE.APPLY_ONLY,
  [RECOMMENDATION_TYPES.SSC_2_PMAX_MIGRATION]: RECOMMENDATION_INLINE_ACTION_TYPE.APPLY_ONLY,
  [RECOMMENDATION_TYPES.PMAX_IMPORT]: RECOMMENDATION_INLINE_ACTION_TYPE.APPLY_ONLY,
  [RECOMMENDATION_TYPES.DSA_2_PMAX_MIGRATION]: RECOMMENDATION_INLINE_ACTION_TYPE.APPLY_ONLY,
  [RECOMMENDATION_TYPES.SYNDICATION_GAP]: RECOMMENDATION_INLINE_ACTION_TYPE.APPLY_ONLY,

  [RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS]: RECOMMENDATION_INLINE_ACTION_TYPE.APPLY_PANEL_EDIT,
  [RECOMMENDATION_TYPES.MULTIMEDIA_ADS]: RECOMMENDATION_INLINE_ACTION_TYPE.APPLY_PANEL_EDIT,
  [RECOMMENDATION_TYPES.IMPROVE_RESPONSIVE_SEARCH_ADS]: RECOMMENDATION_INLINE_ACTION_TYPE.APPLY_PANEL_EDIT,
  [RECOMMENDATION_TYPES.CREATE_CONVERSION_GOAL]: RECOMMENDATION_INLINE_ACTION_TYPE.APPLY_PANEL_EDIT,
  [RECOMMENDATION_TYPES.IMPROVE_MULTIMEDIA_ADS]: RECOMMENDATION_INLINE_ACTION_TYPE.APPLY_PANEL_EDIT,

  [RECOMMENDATION_TYPES.CALLOUT]: RECOMMENDATION_INLINE_ACTION_TYPE.EDIT_ONLY,
  [RECOMMENDATION_TYPES.SITE_LINK]: RECOMMENDATION_INLINE_ACTION_TYPE.EDIT_ONLY,
  [RECOMMENDATION_TYPES.DYNAMIC_SEARCH_ADS]: RECOMMENDATION_INLINE_ACTION_TYPE.EDIT_ONLY,

  [RECOMMENDATION_TYPES.REPAIR_KEYWORD]: RECOMMENDATION_INLINE_ACTION_TYPE.REPAIR,

  [RECOMMENDATION_TYPES.FIX_AD_DESTINATION]: RECOMMENDATION_INLINE_ACTION_TYPE.RESUBMIT_EDIT,


  [RECOMMENDATION_TYPES.SETUP_CONVERSION_TRACKING_OPPORTUNITY]:
    RECOMMENDATION_INLINE_ACTION_TYPE.SETUP_CONV,

  [RECOMMENDATION_TYPES.FIX_CONVERSION_GOAL_SETTINGS]: RECOMMENDATION_INLINE_ACTION_TYPE.HYBRID,

  [RECOMMENDATION_TYPES.GOOGLE_IMPORT]: RECOMMENDATION_INLINE_ACTION_TYPE.EXTERNAL,
  [RECOMMENDATION_TYPES.GOOGLE_IMPORT_SCHEDULED]: RECOMMENDATION_INLINE_ACTION_TYPE.EXTERNAL,
  [RECOMMENDATION_TYPES.FACEBOOK_IMPORT]: RECOMMENDATION_INLINE_ACTION_TYPE.EXTERNAL,
  [RECOMMENDATION_TYPES.FIX_CONVERSION_TRACKING_OPPORTUNITY]:
    RECOMMENDATION_INLINE_ACTION_TYPE.EXTERNAL,
  [RECOMMENDATION_TYPES.REPAIR_ADS]: RECOMMENDATION_INLINE_ACTION_TYPE.EXTERNAL,
};

export const NO_ACTION_RECOMMENDATION_TYPES = [
  RECOMMENDATION_TYPES.FIX_AD_TEXT,
];

export const isGoogleRecommendationType = recommendationType =>
  recommendationType === RECOMMENDATION_TYPES.GOOGLE_IMPORT ||
  recommendationType === RECOMMENDATION_TYPES.GOOGLE_IMPORT_SCHEDULED;

export const isSelectableType = (recommendationType, isMCC = false) => {
  const withoutSelection =
    isGoogleRecommendationType(recommendationType) ||
    recommendationType === RECOMMENDATION_TYPES.FIX_CONVERSION_TRACKING_OPPORTUNITY ||
    (recommendationType === RECOMMENDATION_TYPES.SETUP_CONVERSION_TRACKING_OPPORTUNITY && !isMCC) ||
    recommendationType === RECOMMENDATION_TYPES.FACEBOOK_IMPORT ||
    recommendationType === RECOMMENDATION_TYPES.PMAX_IMPORT;
  return !withoutSelection;
};

export const isDownloadableType = recommendationType =>
  !_.contains(NOT_SUPPORT_DOWNLOAD_TYPES, recommendationType);

export const isAdExtensionRecommendationType = recommendationType =>
  recommendationType === RECOMMENDATION_TYPES.SITE_LINK ||
  recommendationType === RECOMMENDATION_TYPES.CALLOUT;

export const isPopupEditorEnabledRecommendationType = recommendationType =>
  recommendationType === RECOMMENDATION_TYPES.NEW_KEYWORD_OPPORTUNITY ||
  recommendationType === RECOMMENDATION_TYPES.BROAD_MATCH_KEYWORD ||
  recommendationType === RECOMMENDATION_TYPES.TRENDING_QUERY ||
  recommendationType === RECOMMENDATION_TYPES.REPAIR_MISSING_KEYWORD_PARAMS ||
  recommendationType === RECOMMENDATION_TYPES.FIX_NO_IMPRESSION_BID ||
  recommendationType === RECOMMENDATION_TYPES.REPAIR_UNTARGETED_OFFER;

export const SUGGESTED_ADS_COLUMN_MAX_ADS_COUNT = 4;

export const SUPPORT_APPLY_TYPES = [
  RECOMMENDATION_TYPES.BUDGET_OPPORTUNITY,
  RECOMMENDATION_TYPES.ADJUST_SHARED_BUDGET_OPPORTUNITY,
  RECOMMENDATION_TYPES.BROAD_MATCH_KEYWORD,
  RECOMMENDATION_TYPES.NEW_KEYWORD_OPPORTUNITY,
  RECOMMENDATION_TYPES.TRENDING_QUERY,
  RECOMMENDATION_TYPES.REMOVE_CONFLICTING_NEGATIVE_KEYWORD,
  RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS,
  RECOMMENDATION_TYPES.REALLOCATE_BUDGET,
  RECOMMENDATION_TYPES.MULTIMEDIA_ADS,
  RECOMMENDATION_TYPES.IMAGE_EXTENSION,
  RECOMMENDATION_TYPES.REPAIR_MISSING_KEYWORD_PARAMS,
  RECOMMENDATION_TYPES.FIX_NO_IMPRESSION_BID,
  RECOMMENDATION_TYPES.IMPROVE_RESPONSIVE_SEARCH_ADS,
  RECOMMENDATION_TYPES.REPAIR_UNTARGETED_OFFER,
  RECOMMENDATION_TYPES.IMPROVE_MULTIMEDIA_ADS,
  RECOMMENDATION_TYPES.SSC_2_PMAX_MIGRATION,
  RECOMMENDATION_TYPES.DSA_2_PMAX_MIGRATION,
  RECOMMENDATION_TYPES.SYNDICATION_GAP,
];

export const SUPPORT_RESUBMIT_TYPES = [
  RECOMMENDATION_TYPES.FIX_AD_DESTINATION,
];

export const SUPPORT_DISMISS_TYPES = [
  RECOMMENDATION_TYPES.CALLOUT,
  RECOMMENDATION_TYPES.SITE_LINK,
  RECOMMENDATION_TYPES.REPAIR_ADS,
  RECOMMENDATION_TYPES.REPAIR_KEYWORD,
  RECOMMENDATION_TYPES.DYNAMIC_SEARCH_ADS,
  RECOMMENDATION_TYPES.FIX_AD_TEXT,
  RECOMMENDATION_TYPES.SETUP_CONVERSION_TRACKING_OPPORTUNITY,
  RECOMMENDATION_TYPES.FIX_CONVERSION_GOAL_SETTINGS,
  RECOMMENDATION_TYPES.FIX_AD_DESTINATION,
  RECOMMENDATION_TYPES.CREATE_CONVERSION_GOAL,
  RECOMMENDATION_TYPES.BUDGET_OPPORTUNITY,
  RECOMMENDATION_TYPES.ADJUST_SHARED_BUDGET_OPPORTUNITY,
  RECOMMENDATION_TYPES.BROAD_MATCH_KEYWORD,
  RECOMMENDATION_TYPES.NEW_KEYWORD_OPPORTUNITY,
  RECOMMENDATION_TYPES.TRENDING_QUERY,
  RECOMMENDATION_TYPES.REMOVE_CONFLICTING_NEGATIVE_KEYWORD,
  RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS,
  RECOMMENDATION_TYPES.REALLOCATE_BUDGET,
  RECOMMENDATION_TYPES.MULTIMEDIA_ADS,
  RECOMMENDATION_TYPES.IMAGE_EXTENSION,
  RECOMMENDATION_TYPES.REPAIR_MISSING_KEYWORD_PARAMS,
  RECOMMENDATION_TYPES.FIX_NO_IMPRESSION_BID,
  RECOMMENDATION_TYPES.IMPROVE_RESPONSIVE_SEARCH_ADS,
  RECOMMENDATION_TYPES.REPAIR_UNTARGETED_OFFER,
  RECOMMENDATION_TYPES.IMPROVE_MULTIMEDIA_ADS,
  RECOMMENDATION_TYPES.DSA_2_PMAX_MIGRATION,
  RECOMMENDATION_TYPES.SYNDICATION_GAP,
];

export const SUPPORT_DISMISS_ALL_TYPES = [
  RECOMMENDATION_TYPES.CALLOUT,
  RECOMMENDATION_TYPES.SITE_LINK,
  RECOMMENDATION_TYPES.REPAIR_ADS,
  RECOMMENDATION_TYPES.REPAIR_KEYWORD,
  RECOMMENDATION_TYPES.DYNAMIC_SEARCH_ADS,
  RECOMMENDATION_TYPES.FIX_AD_TEXT,
  RECOMMENDATION_TYPES.SETUP_CONVERSION_TRACKING_OPPORTUNITY,
  RECOMMENDATION_TYPES.FIX_CONVERSION_GOAL_SETTINGS,
  RECOMMENDATION_TYPES.FIX_AD_DESTINATION,
  RECOMMENDATION_TYPES.CREATE_CONVERSION_GOAL,
  RECOMMENDATION_TYPES.BUDGET_OPPORTUNITY,
  RECOMMENDATION_TYPES.ADJUST_SHARED_BUDGET_OPPORTUNITY,
  RECOMMENDATION_TYPES.BROAD_MATCH_KEYWORD,
  RECOMMENDATION_TYPES.NEW_KEYWORD_OPPORTUNITY,
  RECOMMENDATION_TYPES.TRENDING_QUERY,
  RECOMMENDATION_TYPES.REMOVE_CONFLICTING_NEGATIVE_KEYWORD,
  RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS,
  RECOMMENDATION_TYPES.REALLOCATE_BUDGET,
  RECOMMENDATION_TYPES.MULTIMEDIA_ADS,
  RECOMMENDATION_TYPES.IMAGE_EXTENSION,
  RECOMMENDATION_TYPES.REPAIR_MISSING_KEYWORD_PARAMS,
  RECOMMENDATION_TYPES.FIX_NO_IMPRESSION_BID,
  RECOMMENDATION_TYPES.IMPROVE_RESPONSIVE_SEARCH_ADS,
  RECOMMENDATION_TYPES.REPAIR_UNTARGETED_OFFER,
  RECOMMENDATION_TYPES.IMPROVE_MULTIMEDIA_ADS,
  RECOMMENDATION_TYPES.FIX_CONVERSION_TRACKING_OPPORTUNITY,
  RECOMMENDATION_TYPES.GOOGLE_IMPORT,
  RECOMMENDATION_TYPES.GOOGLE_IMPORT_SCHEDULED,
  RECOMMENDATION_TYPES.FACEBOOK_IMPORT,
  RECOMMENDATION_TYPES.PMAX_IMPORT,
  RECOMMENDATION_TYPES.DSA_2_PMAX_MIGRATION,
  RECOMMENDATION_TYPES.SYNDICATION_GAP,
];
export const SUPPORT_DOWNLOAD_TYPES =
  _.without(_.clone(SUPPORT_DISMISS_TYPES), ...NOT_SUPPORT_DOWNLOAD_TYPES);

export const SUPPORT_DATE_FILTER_TYPES = [
  RECOMMENDATION_TYPES.FIX_AD_DESTINATION,
  RECOMMENDATION_TYPES.FIX_AD_TEXT,
];

export const DATE_FILTER_STRING_TYPES = {
  LAST_THREE_MONTH: 'Dropdown_Button_LastThreeMonth',
  LAST_SIX_MONTH: 'Dropdown_Button_LastSixMonth',
};

export const SUPPORT_GENERATED_FROM_FILTER_TYPES = [
  RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS,
];

export const GENERATED_FROM_FILTER_STRING_TYPES = {
  AllAssets: 'AllAssets',
  UserAssets: 'UserAssets',
  AIGeneratedAssets: 'AIGeneratedAssets',
};

export const GENERATED_FROM_FILTER_STRING_VALUES = {
  AllAssets: 'All assets',
  UserAssets: 'Existing assets',
  AIGeneratedAssets: 'AI-generated assets',
};

export const getSearchTermChartData = (searchTermList) => {
  const searchTerms = _.sortBy(searchTermList, 'searchTermKpi').reverse();

  const items = _.map(searchTerms, item => ({
    name: item.searchTerm,
    data: [item.searchTermKpi],
  }));

  return {
    selectedMetric: 'SearchTerms',
    localizeCategory: true,
    category: 'Search_Terms',
    items,
  };
};

export const isKeywordRecsChange = (opportunity, recommendationType, i18n) => {
  // If match type is changed, return true.
  if (!_.isUndefined(opportunity.NewMatchType)) {
    const newMatchType = opportunity.NewMatchType;
    const suggestedMatchType = recommendationType === RECOMMENDATION_TYPES.BROAD_MATCH_KEYWORD ?
      opportunity.SuggestedMatchType : opportunity.MatchType;
    if (newMatchType !== suggestedMatchType) {
      return true;
    }
  }

  // If ad group is changed, return true.
  if (!_.isUndefined(opportunity.NewAdGroupId)
    && opportunity.NewAdGroupId !== opportunity.Target.AdGroupId) {
    return true;
  }

  // If bid is changed, return true.
  if (!_.isUndefined(opportunity.NewBid)) {
    const newBid = formatBid(opportunity.NewBid, i18n);
    const suggestedBid = recommendationType === RECOMMENDATION_TYPES.BROAD_MATCH_KEYWORD ?
      opportunity.SuggBid : opportunity.SuggestedBid;
    if (newBid !== formatBid(suggestedBid, i18n)) {
      return true;
    }
  }

  return false;
};

export const isSuggestedBidSupported = opportunity =>
  (opportunity && opportunity.Target && (_.isUndefined(opportunity.Target.BidStrategyTypeId) ||
    _.isNull(opportunity.Target.BidStrategyTypeId) ||
    opportunity.Target.BidStrategyTypeId === 1 ||
    opportunity.Target.BidStrategyTypeId === 5));

export function InlineCampaignAdGroupEditableSave({
  key,
  view,
  updated,
  editorView,
  isCampaign,
}) {
  const value = updated.Name;
  const recommendation = view.grid.gridView.itemWithKey(key);
  if (!_.isNull(recommendation)) {
    if (isCampaign) {
      _.first(recommendation.Opportunities).NewCampaignName = value;
    } else {
      _.first(recommendation.Opportunities).NewAdGroupName = value;
    }

    // Append the current selected one into existing selected ones.
    const selectedKeys = view.grid.gridView.selectedKeys();
    if (!_.contains(selectedKeys, key)) {
      selectedKeys.push(key);
    }
    view.grid.gridView.set({ selection: _.defaults({ selected: selectedKeys }) });
  }
  editorView.trigger('cancel');
}
